var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPesoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.568,
    height: 20.621,
    viewBox: "0 0 19.568 20.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12736",
    "data-name": "Group 12736",
    transform: "translate(0.536 0.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6046",
    "data-name": "Path 6046",
    d: "M2017.14,736.518c-.173-.038-.347-.069-.518-.115a3.557,3.557,0,0,1-2.6-4.163c.429-2.344.828-4.693,1.248-7.039a7.2,7.2,0,0,1,.425-1.833,3.433,3.433,0,0,1,3.1-2.12c.647-.036,1.3-.01,1.947-.012h.245a2.732,2.732,0,0,1-.273-2.6,2.638,2.638,0,0,1,1.1-1.277,2.7,2.7,0,0,1,3.161.275,2.65,2.65,0,0,1,.91,1.69,2.755,2.755,0,0,1-.458,1.9c.1,0,.161.01.227.01.636,0,1.273-.013,1.908.008a3.5,3.5,0,0,1,3.392,2.908c.37,2.019.718,4.042,1.074,6.063.132.751.275,1.5.389,2.254a3.528,3.528,0,0,1-2.977,4.01c-.055.009-.109.027-.163.041Zm6.065-1.151c1.883,0,3.766,0,5.648,0a2.373,2.373,0,0,0,2.444-2.574,14.532,14.532,0,0,0-.237-1.467c-.4-2.271-.81-4.54-1.2-6.813a2.416,2.416,0,0,0-2.481-2.122q-2.118,0-4.236,0c-1.431,0-2.863-.023-4.293.011a2.272,2.272,0,0,0-2.029,1.3,4.638,4.638,0,0,0-.361,1.434q-.612,3.414-1.21,6.831a3.791,3.791,0,0,0-.081,1.53,2.407,2.407,0,0,0,2.409,1.866Q2020.389,735.372,2023.2,735.367Zm-.014-14.135a1.571,1.571,0,0,0,1.574-1.538,1.551,1.551,0,0,0-1.526-1.563,1.523,1.523,0,0,0-1.577,1.524A1.54,1.54,0,0,0,2023.19,721.232Z",
    transform: "translate(-2013.96 -716.972)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6047",
    "data-name": "Path 6047",
    d: "M2217.656,917.823c-.1,0-.189,0-.278,0a.572.572,0,0,1-.011-1.144c.311-.012.624-.011.935,0a.537.537,0,0,1,.525.47,2.353,2.353,0,0,1-.256,1.513,1.837,1.837,0,0,1-3.143.016,1.867,1.867,0,0,1-.284-1.014c0-.388-.006-.776,0-1.164a1.861,1.861,0,0,1,1.948-1.88,1.8,1.8,0,0,1,1.335.681.572.572,0,0,1-.045.807.562.562,0,0,1-.805-.037.738.738,0,0,0-.762-.274.639.639,0,0,0-.5.564c-.017.483-.02.967,0,1.449a.675.675,0,0,0,1.337.013Z",
    transform: "translate(-2205.54 -905.184)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6048",
    "data-name": "Path 6048",
    d: "M2124.065,917.7c0,.444.006.848,0,1.251a.574.574,0,1,1-1.147-.035c0-.75,0-1.5,0-2.251,0-.483,0-.967,0-1.45a.576.576,0,1,1,1.148,0c0,.387,0,.774,0,1.209.074-.071.123-.114.167-.16q.7-.726,1.406-1.454a.59.59,0,0,1,.581-.207.573.573,0,0,1,.28.973c-.385.414-.783.817-1.18,1.221a2.758,2.758,0,0,1-.283.221c.089.1.135.147.182.2q.636.659,1.273,1.317a.567.567,0,0,1,.141.632.54.54,0,0,1-.491.365.609.609,0,0,1-.505-.219q-.7-.729-1.406-1.453C2124.186,917.813,2124.14,917.773,2124.065,917.7Z",
    transform: "translate(-2117.715 -905.158)",
    fill: "#394f65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesoImage);
export default __webpack_public_path__ + "static/media/peso_image.e7412c08d6f64b22545c7c99467ff4a0.svg";
export { ForwardRef as ReactComponent };